'use strict';

window.TES = window.TES || {};

window.TES.et = {
    send: function(event) {
        var data = JSON.stringify(event);
        var url = '/et/' + window.Base64.encode(data) + '?&_cb=' + Math.random()*10000000;
        var pixel = new Image(1,1);
        pixel.src = url;
    }
};